export const VPNACCOUNT_DETAILS = "VPNACCOUNT_DETAILS";
export const RESELLER_DETAILS = "RESELLER_DETAILS";
